export const BREAKPOINTS = {
	xsDevice: 300,
	smDevice: 405,
	mdDevice: 700,
	lgDevice: 1042,
	xlDevice: 1250
};
